import { render, staticRenderFns } from "./FreezerLocation.vue?vue&type=template&id=1a0d17da&"
import script from "./FreezerLocation.vue?vue&type=script&lang=js&"
export * from "./FreezerLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports